const faqs = [
  {
    q: '暗网到底是什么？',
    a: '暗网是互联网中无法被常规搜索引擎索引的部分，需要通过特定软件（如Tor浏览器）才能访问。它不同于深网（如企业内部网、学术数据库），暗网强调匿名性和隐蔽性。暗网上有合法的匿名交流平台，也存在非法交易市场。了解暗网有助于更好地理解互联网的完整面貌和安全风险。',
  },
  {
    q: '暗网怎么进入？需要哪些工具？',
    a: '进入暗网最基本的工具是Tor浏览器，可以从Tor Project官网免费下载。建议搭配可靠的VPN使用以获得额外安全层。配置要点包括：禁止JavaScript、调整安全级别、关闭WebRTC等。本站暗网入门指南提供了从下载到配置的完整图文教程。',
  },
  {
    q: 'Tor浏览器安全吗？如何下载正版？',
    a: 'Tor浏览器是目前最成熟的暗网访问工具，基于Firefox ESR开发并内置多层加密。务必从 torproject.org 官网下载，避免使用第三方下载站。下载后校验签名确保文件未被篡改。Tor浏览器本身是合法软件，在全球范围内被广泛用于隐私保护。',
  },
  {
    q: '访问暗网违法吗？有什么法律风险？',
    a: '使用Tor浏览器本身在全球绝大多数国家是合法的。但暗网上的某些内容和活动可能违法。我们建议仅将暗网用于合法的匿名通信和信息获取。51暗网仅提供技术指南和安全知识，不鼓励任何违法活动。请遵守你所在地区的法律法规。',
  },
  {
    q: '暗网网址从哪里获取？链接总是失效怎么办？',
    a: '暗网网址（.onion地址）由于网络特性可能频繁变更。推荐通过Ahmia、Torch等暗网专用搜索引擎查找，或关注51暗网的暗网网址导航页面——我们每周人工验证链接可用性并更新。也欢迎通过匿名投稿通道分享你知道的有效链接。',
  },
  {
    q: '暗网吃瓜爆料的内容可信吗？',
    a: '暗网上的信息真伪难辨，我们强烈建议对任何匿名爆料保持谨慎态度。51暗网对投稿内容会进行基本核实，但无法保证100%准确性。我们标注了每条信息的来源类型，建议读者多方交叉验证。吃瓜虽有趣，但切勿将未经证实的信息当作事实传播。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100 text-center mb-3">
          常见问答
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10 max-w-lg mx-auto">
          关于暗网最常被问到的问题，一次解答清楚
        </p>

        <div className="max-w-3xl mx-auto flex flex-col gap-4">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 border border-background-200/60 rounded-lg p-5 md:p-6"
            >
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-100 mb-3 flex items-start gap-3">
                <span className="text-primary-400 shrink-0 mt-0.5">
                  <i className="ri-question-answer-line"></i>
                </span>
                <span>{faq.q}</span>
              </h3>
              <p className="text-foreground-600 text-xs md:text-sm leading-relaxed pl-7">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}